import DsUpload from './DsUpload'

export default Vue => {
  Vue.component(DsUpload.name, DsUpload)
}



// WEBPACK FOOTER //
// ./src/components/dsupload/index.js